<template>
    <a      :href="href"
            class="plain-link col-span-1 flex shadow-sm rounded-md cursor-pointer">
        <div    :class="iconBackgroundColor"
                class="shrink-0 flex items-center justify-center w-10 md:w-16 text-white text-sm  leading-5 font-medium rounded-l-md">
            <!-- Icon -->
            <span   :class="icon"
                    class="lnr text-white"></span>
        </div>

        <!-- Main Link text and icons -->
        <div class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
            <!-- Link Text -->
            <div class="flex-1 px-4 py-4 text-sm leading-5 truncate">
                                <span class="text-gray-900 font-medium hover:text-gray-600">
                                    {{ text }}
                                </span>
            </div>

            <!-- Arrow Button -->
            <div class="shrink-0 pr-2">
                <button
                    class="w-8 h-8 inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:text-gray-500 focus:bg-gray-100">
                    <span class="lnr icon-arrow-right"></span>
                </button>
            </div>
        </div>
    </a>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import UndecoratedLink from "@/components/EnterpriseDashboard/undecorated-link.vue";

export default {
    name: "SettingPageLinkWithIcon",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {},
    emits: [],
    props: {
        href: {
            type: [String, null],
            default: null,
        },
        icon: {
            type: [String, null],
            default: null,
        },
        text: {
            type: String,
            default: 'Setting Item'
        },
        isPartnerOnlyLink: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {}
    },
    created() {

    },
    mounted() {

    },
    methods: {},
    computed: {
        iconBackgroundColor() {
            return this.isPartnerOnlyLink
                ? 'bg-blue-900'
                : 'bg-blue-500'
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>